import { Injectable } from '@angular/core';
import { ProjectStatusRequiredFieldsComponent } from '../../modals/project-status-required-fields/project-status-required-fields.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { catchError, map, take } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';
import { ProjectsService } from '../../projects.service';
import { Observable } from 'rxjs';
import { Project } from '../../projects.types';
import { PartialFormField } from 'app/shared/components/form-fields/form-field.types';

@Injectable({
  providedIn: 'root',
})
export class UpdateProjectStatusService {
  constructor(
    private readonly matDialog: MatDialog,
    private readonly projectsService: ProjectsService,
  ) {}

  update(data: any, project: Project, newProject: PartialFormField): Observable<boolean | Project> {
    const stage = data.options.project_stages.filter((option) => +option.id === +newProject.project_stage_id)[0];

    if (stage && stage.required_fields) {
      const wrapper = document.querySelector('.cdk-global-overlay-wrapper');
      if (wrapper) wrapper.remove();

      return this.matDialog
        .open(ProjectStatusRequiredFieldsComponent, {
          panelClass: 'mailbox-compose-dialog',
          data: { data, stage, project: { ...project, ...newProject } },
        })
        .afterClosed()
        .pipe(
          take(1),
          map((modalResponse: { updatedProject: boolean }) => {
            return modalResponse?.updatedProject || false;
          }),
        );
    } else {
      return this.projectsService.saveProject({ ...newProject, project_stage: stage }, project, false, true).pipe(
        take(1),
        catchError((error) => {
          console.error(error);
          return of(false);
        }),
      );
    }
  }
}
